import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
// import Financialreportheader from "./Financialreportheader";
// import Financialreportfooter from "./Financialreportfooter";
// import Financialreporttable from "./FinancialReporttable";
// import { UserListData } from "./UserListData";
// import Financialreportdatepicker from "./Financialreportdatepicker";
// import UserListheader from "./UserListheader";
// import UserListtable from "./UserListtable";
// import Searchbaruserlist from "./Searchbaruserlist";
// import Modaluserlist from "./Modaluserlist";
import Searchbarchapterlist from "./Searchbarchapterlist";
import Modalchapterlist from "./Modalchapterlist";
import ChapterListtable from "./ChapterListtable";
import { ChapterListData } from "./ChapterListData";
import ChapterListheader from "./ChapterListheader";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem, InputLabel } from "@mui/material";
import Loader from "../../pages/Loader/Loader";
import Nochapter from "../../pages/Nochapter/Nochapter";
import axios from "axios";

const Chapterlist = (props) => {
  const [course, setCourse] = useState("");
  const [chapterList, setChapterList] = useState([]);
  const [pending, setPending] = useState(false);
  // const [renderchapter,setRenderchapter] = useState(false);
  const { courses, render, setRender } = props;
  // let items = chapters;
  // console.log("chapters items hello", items);
  const handleChange = (e) => {
    console.log(e.target.value.name);
    setCourse(e.target.value);
    const getChapterList = async () => {
      console.log(
        "api url",
        `api/v1/a34jl49u-q4r67p89/courses/${e.target.value?.name}/chapter`
      );
      const request = {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          withCredentials: true,
          // Authorization: token,
        },
      };
      setPending(true);
      fetch(
        `api/v1/a34jl49u-q4r67p89/courses/${e.target.value._id}/chapter`,
        request
      )
        .then((response) => response.json())
        .then((res) => {
          console.log("chapters api res", res.chapter);
          setChapterList(res.chapter);
          setPending(false);
        })
        .catch((err) => console.log("err", err));
    };
    getChapterList();
    // useEffect(() => {
    //   getChapterList();
    // }, []);
  };
  // useEffect(()=>{
  //   handleChange();
  // })
  // fetch("https://oakaweapi.herokuapp.com/api/v1/a34jl49u-q4r67p89/courses", {
  //   method: "GET",
  //   credentials: "include",
  //   withCredentials: true,
  //   crossDomain: true,
  //   headers: {
  //     "Access-Control-Allow-Origin": "*",
  //     "Content-Type": "application/json",
  //   },
  //   // mode: 'no-cors',
  // })
  //   .then((response) => response.json())
  //   .then((json) => {
  //     console.log(json);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  // console.log("hello kths", chapterList.length);
  const chapterlength = chapterList?.length;
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          marginTop: 3,
          borderRadius: 2,
          border: "1px solid #e0e0ef",
        }}
      >
        {/* <Typography sx={{ background: "#F7F7F7",color:'#000',padding:2,borderBottom: "2px solid #F2F2F2",borderTopLeftRadius:8,borderTopRightRadius:8 }}>Financial Report</Typography> */}
        <Box sx={{ padding: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Searchbarchapterlist />
            {/* {courses?.map((course, index) => (
              
            ))} */}
            <Modalchapterlist
              courses={courses}
              // renderchapter={renderchapter}
              // setRenderchapter={setRenderchapter}
              render={render}
              setRender={setRender}
            />
          </Box>
          <FormControl sx={{ width: "300px", marginBottom: 2 }}>
            <InputLabel id="demo-simple-select-label">Course</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={course}
              label="Course"
              onChange={handleChange}
              // onClick={console.log("hello")}
              // onClick={chapterList}
              // onChange={(e)=>{
              //   // getChapterList();
              //   console.log(course?.name);
              //   // course(e.target.value)
              //   // setCourse(course?.name);
              //   setCourse(e.target.value);
              // }}
            >
              {courses?.map((course, index) => (
                <MenuItem key={index} value={course}>
                  {course?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {!pending ? (
            <Box sx={{ overflowY: "hidden", overflowX: "scroll" }}>
              {chapterList.length !== 0 ? (
                <>
                  <ChapterListheader />
                  {chapterList?.map((item, index) => (
                    <ChapterListtable
                      chapterlength={chapterlength}
                      courses={courses}
                      render={render}
                      setRender={setRender}
                      no={index}
                      item={item}
                      key={index}
                    />
                  ))}
                </>
              ) : (
                <Nochapter />
              )}
              {/* <Financialreportdatepicker/> */}
            </Box>
          ) : (
            <Loader />
          )}
        </Box>
      </Box>
    </>
  );
};

export default Chapterlist;
